export const kuma = {
  id: "kuma",
  link: "/#/recipes/recipes/kuma",
  name: "Kuma",
  cuisine: "Alethi",
  summary: "A spiced spread, similar to hummus",
  inspiration: "Hummus",
  quantity: "2 1/2 cups",
  time: "10 minutes",
  notes:
    "The book describes a paste made of grain and spices served on flatbread. That sounds like hummus to me. I just tweaked the ingredients to match what the Alethi would have used.",
  quotes:
    "Bridge Four was sharing a meal of flatbread with kuma — crushed lavis and spices. (Oathbringer ch 121)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/kuma-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "tahini",
          display: "1/3 cup tahini"
        },
        {
          item: "lemon",
          display: "1/3 cup lemon juice"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "cumin",
          display: "1 tsp cumin"
        },
        {
          item: "coconut",
          display: "2 tbsp coconut oil"
        },
        {
          item: "salt",
          display: "3/4 tsp salt"
        },
        {
          item: "paprika",
          display: "1 tsp paprika"
        },
        {
          item: "gochugaru",
          display: "1 1/2 tsp gochu garu, divided"
        },
        {
          item: "coriander",
          display: "1/2 tsp coriander"
        },
        {
          item: "hominy",
          display: "1 25 oz can hominy"
        },
        {
          item: "sesame",
          display: "1/2 tsp toasted sesame oil"
        },
        {
          item: "sesame",
          display: "1/2 tsp sesame seeds"
        }
      ]
    }
  ],
  steps: [
    "Before measuring the tahini, stir it well. It tends to separate in the jar.",
    "In a food processor, combine tahini and lemon juice. Process 30 seconds, then stop and scrape the sides. Process for another 30 seconds.",
    "Add garlic, cumin, coconut oil, salt, paprika, 1 tsp gochu garu, and coriander. Drain the can of hominy, but reserve the liquid. Add the hominy to the other ingredients in the food processor. Process until smooth. Add 1 tbsp of the reserved liquid and process until it forms a spreadable paste. If needed or desired, add additional reserved liquid to make a thinner spread. Garnish with toasted sesame oil, sesame seeds, and 1/4 tsp gochu garu. Serve with flatbread or anything you would eat hummus with."
  ]
}
